import React, { PropTypes } from 'react';
import PureComponent from 'components/PureComponent';
import WaveLink from 'components/WaveLink';
import { Link } from 'react-router';

import arrow from './arrow.svg';

class Next extends PureComponent {

	static propTypes = {
		to: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired
	};

	render() {
		require('./Next.styl');

		return (
			<Link to={this.props.to} className="Next">
				<div className="Next__w">
					<div>ДАЛЕЕ</div>
					<WaveLink color="#FFF" element="p">
						<span dangerouslySetInnerHTML={{__html: this.props.label}} />
					</WaveLink>
					<img src={arrow} width="18" height="16" />
				</div>
			</Link>
		);
	}

}

export default Next;



// WEBPACK FOOTER //
// ./src/components/Next/Next.js